import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {PrescriptionSummaryModel} from '../prescriptionSummary.model';
import {PermissionsConverter} from '../../../../../../common/converter/permissions.converter';
import {DateConverter} from '../../../../../../common/converter/date.converter';
import {PartnerSummaryConverter} from '../../../../../../partner/common/api/converter/partnerSummary.converter';
import {DocumentSummaryConverter} from '../../../../../../document/common/api/converter/DocumentSummary.converter';


@Injectable({providedIn: 'root' })
    export class PrescriptionSummaryConverter extends HttpModelConverter<PrescriptionSummaryModel>{
    constructor(private permissionsConverter: PermissionsConverter,
                private dateConverter: DateConverter,
                private partnerSummaryConverter: PartnerSummaryConverter,
                private documentSummaryConverter: DocumentSummaryConverter) {
        super();
    }
    protected createInstance(): PrescriptionSummaryModel {
        return new PrescriptionSummaryModel();
    }

    protected enrichObject(result: PrescriptionSummaryModel, src: PrescriptionSummaryModel) {
        result.permissions = this.permissionsConverter.convert(src.permissions);
        result.date = this.dateConverter.convert(src.date);
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.document = this.documentSummaryConverter.convert(src.document);
    }
}
